import { Inject, Injectable, Injector } from '@angular/core';

import { FootprintEdi_ReportService } from './FootprintEdi.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintEdi = this.injector.get(FootprintEdi_ReportService);
  }
    public FootprintEdi: FootprintEdi_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

